import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import {
  TradeTaxDeclarationStatus,
  UpdateTradeTaxDeclarationInput as GeneratedUpdateTradeTaxDeclarationInput,
} from "../../schema.generated";
import { TradeTaxDeclaration } from "../../types";

/*
 * `resetApproval` comes from the generated schema rather than being restated
 * here: it confirms that moving the declaration into "Warten auf
 * Kundenfreigabe" may reset the approval the customer gave for the previous
 * version. Without it the backend refuses that status change with
 * APPROVAL_RESET_REQUIRED. A save that leaves the status unchanged never
 * needs it.
 */
export interface UpdateTradeTaxDeclarationInput
  extends Pick<GeneratedUpdateTradeTaxDeclarationInput, "resetApproval"> {
  status: TradeTaxDeclarationStatus;
  hasMultipleMunicipalities: boolean;
  municipality: string | null;
  municipalityTaxRate: number | null;
  taxOfficeBalance: number | null;
}

export interface UpdateTradeTaxDeclarationMutationVariables {
  email: string;
  year: number;
  payload: UpdateTradeTaxDeclarationInput;
}

export interface UpdateTradeTaxDeclarationMutationResult {
  updateTradeTaxDeclaration: TradeTaxDeclaration;
}

export const UPDATE_TRADE_TAX_DECLARATION_MUTATION = gql`
  mutation updateTradeTaxDeclaration(
    $email: String!
    $year: Int!
    $payload: UpdateTradeTaxDeclarationInput!
  ) {
    updateTradeTaxDeclaration(email: $email, year: $year, payload: $payload) {
      status
      statusUpdatedAt
      hasMultipleMunicipalities
      municipality
      municipalityTaxRate
      taxOfficeBalance
    }
  }
`;

export const useUpdateTradeTaxDeclarationMutation = (
  options?: MutationHookOptions<
    UpdateTradeTaxDeclarationMutationResult,
    UpdateTradeTaxDeclarationMutationVariables
  >
) =>
  useMutation<
    UpdateTradeTaxDeclarationMutationResult,
    UpdateTradeTaxDeclarationMutationVariables
  >(UPDATE_TRADE_TAX_DECLARATION_MUTATION, options);
